var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 13.3337C18.9458 13.3337 21.3337 10.9458 21.3337 8.00033C21.3337 5.05481 18.9458 2.66699 16.0003 2.66699C13.0548 2.66699 10.667 5.05481 10.667 8.00033C10.667 10.9458 13.0548 13.3337 16.0003 13.3337Z",
    stroke: "#0D216D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 23.334C26.6668 26.6473 26.6668 29.334 16.0002 29.334C5.3335 29.334 5.3335 26.6473 5.3335 23.334C5.3335 20.0207 10.1095 17.334 16.0002 17.334C21.8908 17.334 26.6668 20.0207 26.6668 23.334Z",
    stroke: "#0D216D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.1ef625cc07052291baa5b1fc7c856cb3.svg";
export { ForwardRef as ReactComponent };